import React, { useState } from "react";
import './HomePageGoogle.scss';
import emailjs from 'emailjs-com';
import { Helmet } from "react-helmet";
// images
import reslock from '../../Images/reslock.png'
import Checklist from '../../Images/checklist.png'
import { useLocation, useNavigate } from "react-router-dom";

export default function HomePageGoogle({ CitiePhone, CitiesData }) {
    const location = useLocation()
    const navigate = useNavigate()
    return (
        <div className="HomePageGoogle" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Day & Night Locksmith  | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content=" | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content=" | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.Day & Night daynightlocksmith.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content=" provides top-quality chimney cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your chimney service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content=" provides top-quality chimney cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your chimney service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="" data-react-helmet="true" />
                <meta name="keywords" content=", chimney Inspection, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, chimney services, chimney service, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Insulation, Chimney Installation, Chimney Liner Repair, Chimney Pointing, Chimney Rainp Installation, Chimney Repair, Chimney Crown Repair, Chimney Restoration, Chimney Flue Installation, Chimney Flue Repair, ​Chimney Construction, Chimney Vent Installation, Chimney Flashing, Flexible Chimney Liner Installation, Chimney Damper Repair, Chimneyp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}

            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>24/7 Emergency {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}  Locksmiths</h1>
                    <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas - Fast, Same-Day Locksmith Services.</h2>
                    {/* <h2>Chimney Cleaning Near Me</h2> */}
                    <div className="MainBannerLeftBen">
                        <h3><img src={Checklist} alt="Locally Owned & Operated Day & Night Locksmith  Repair" />Locally Owned & Operated</h3>
                        <h3><img src={Checklist} alt="Licensed | Bonded | Insured Day & Night Locksmith  Repair" />Licensed | Bonded | Insured</h3>
                        <h3><img src={Checklist} alt="Satisfaction Guaranteed Day & Night Locksmith  Repair" />Satisfaction Guaranteed</h3>
                    </div>
                    <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>
                    <a href={`tel:${CitiePhone}`}>Call Now {CitiePhone}</a>
                </div>
                <div className="MainBannerRight">
                    <img src={require(`../../Images/locksmith12.png`)} />
                </div>
            </div>
            <div className="MainBanner2Top2" id="ourservices">
                <div className="MainBanner2TopBox">
                    <h1>24/7 Emergency {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}  Locksmiths</h1>
                    <div className="MainBanner2TopBoxMenu">
                        <a className="MainBanner2TopBoxBox">
                            <img src={require(`../../Images/locksmith11.png`)} />
                            <h3>Residential Locksmith</h3>
                            <p><span></span>House Lockout Services</p>
                            <p><span></span>Lock Rekeying & Repairs</p>
                            <p><span></span>Smart Lock Installation</p>
                            <p><span></span>Change Locks On House</p>
                            <p><span></span>Replace Locks On House</p>
                            <p><span></span>New Lock Installation</p>
                            <p><span></span>And More</p>
                            <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>
                        </a>
                        <a className="MainBanner2TopBoxBox">
                            <img src={require(`../../Images/locksmith12.png`)} />
                            <h3>Commercial Locksmith</h3>
                            <p><span></span>Business / Office Lockout</p>
                            <p><span></span>Change Commercial Door Locks</p>
                            <p><span></span>Commercial Rekey Services</p>
                            <p><span></span>Safe Lockout Assistance</p>
                            <p><span></span>Storefront Door Lock Replacement</p>
                            <p><span></span>Apartment Complexes & Hotels</p>
                            <p><span></span>And More</p>
                            <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>
                        </a>
                        <a className="MainBanner2TopBoxBox">
                            <img src={require(`../../Images/locksmith16.png`)} />
                            <h3>Automotive Locksmith</h3>
                            <p><span></span>Car Lockout </p>
                            <p><span></span>Vehicle Key Making </p>
                            <p><span></span>Ignition Replacement </p>
                            <p><span></span>Duplicate Car Keys </p>
                            <p><span></span>Car Key Extraction </p>
                            <p><span></span>Replace Car Keys </p>
                            <p><span></span>And More </p>
                            <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>
                        </a>
                    </div>
                </div>
            </div>
            <div className="AirDuctReviews" id="reviews">
                <h1>Read Our Latest 5-Star Reviews</h1>
                <div className="AirDuctReviewsList">
                    <img className="ImgHomePageGoogleHowContactMainRightBox" src={require(`../../Images/review1airduct.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/review3airduct.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/review2airduct.png`)} />
                </div>
                <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>
                <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
            </div>
            <div className="HomePageGoogleHowContact">
                <h3>Getting Your Locksmith Service Is Fast and Easy</h3>
                <div className="HomePageGoogleHowContactMain">
                    <img src={reslock} alt="Locksmith Service" />
                    <div className="HomePageGoogleHowContactMainRight">
                        <div className="HomePageGoogleHowContactMainRightBox">
                            <img className="ImgHomePageGoogleHowContactMainRightBox" src={require(`../../Images/checklist.png`)} />
                            <div className="HomePageGoogleHowContactMainRightBoxRight">
                                <h1>Step 1</h1>
                                <h2>Call us at <a href={`tel:{CitiePhone}`}>{CitiePhone}</a> and explain your locksmith needs. Our team will provide you with an accurate quote over the phone.</h2>
                            </div>
                        </div>
                        <div className="HomePageGoogleHowContactMainRightBox">
                            <img className="ImgHomePageGoogleHowContactMainRightBox" src={require(`../../Images/checklist.png`)} />
                            <div className="HomePageGoogleHowContactMainRightBoxRight">
                                <h1>Step 2</h1>
                                <h2>We’ll dispatch a professional locksmith to your location promptly, ready to resolve your issue.</h2>
                            </div>
                        </div>
                        <div className="HomePageGoogleHowContactMainRightBox">
                            <img className="ImgHomePageGoogleHowContactMainRightBox" src={require(`../../Images/checklist.png`)} />
                            <div className="HomePageGoogleHowContactMainRightBoxRight">
                                <h1>Step 3</h1>
                                <h2>Relax as we complete your locksmith service efficiently and professionally, ensuring your satisfaction.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="MainBannerGoodBY">
                <h1>SAY GOODBYE TO LOCKOUTS AND SECURITY WORRIES</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience peace of mind with our professional locksmith services for your home, business, and vehicle.</h2>
                <div className="MainBannerGoodBYList">
                    {/* locksmith11.png */}
                    <img src={require(`../../Images/car2lock.png`)} />
                    <img src={require(`../../Images/res2lock.png`)} />
                    <img src={require(`../../Images/locksmith14.png`)} />
                    <img src={require(`../../Images/locksmith15.png`)} />
                </div>
                <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>
                <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
            </div>
            <div className="AirDuctServices" id="ourservices">
                <h1>OUR LOCKSMITH SERVICES</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h6>Enjoy unmatched reliability with our expert locksmith solutions tailored for residential, commercial, and automotive needs.</h6>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/locksmith11.png`)} alt="Residential Locksmith Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>RESIDENTIAL LOCKSMITH SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />House Lockout</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Lock Rekeying</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Smart Lock Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Lock Repairs</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Change Locks On House</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Replace Locks On House</h2>
                            </div>
                            <h4>Protect your home with our reliable residential locksmith services, including house lockout solutions, lock rekeying, new lock installations, and residential lock repair near you. Call now for fast and secure service!</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/locksmith12.png`)} alt="Commercial Locksmith Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>COMMERCIAL LOCKSMITH SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Office Lockouts</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />High-Security Lock Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Storefront Door Lock Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Commercial Lock Rekey</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Business Lock Repairs</h2>
                            </div>
                            <h4>Secure your business with specialized commercial locksmith services. From commercial door lock replacement to business lockout assistance, our professionals offer reliable solutions to safeguard your property. Call today for prompt service!</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/locksmith16.png`)} alt="Automotive Locksmith Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>AUTOMOTIVE LOCKSMITH SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Car Lockout Services</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Ignition Key Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duplicate Car Keys</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Transponder Key Programming</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Replace Car Keys</h2>
                            </div>
                            <h4>Locked out of your car? Need ignition key replacement or transponder programming? Our automotive locksmith services are fast, efficient, and available 24/7. Call now for immediate assistance!</h4>
                        </div>
                    </a>
                </div>
            </div>
            <div className="HomePageGoogleConta">
                <h1>CONTACT US FOR ANY TYPE OF</h1>
                <h2>LOCKSMITH {CitiesData.City} SERVICES</h2>
                <div className="HomePageGoogleContaList">
                    <div className="HomePageGoogleContaBox">
                        <img src={require(`../../Images/telephone.png`)} />
                        <h3>Phone</h3>
                        <h4>{CitiePhone}</h4>
                    </div>
                    <div className="HomePageGoogleContaBox">
                        <img src={require(`../../Images/mail.png`)} />
                        <h3>Email</h3>
                        <h4>info@daynightlocksmith.com</h4>
                    </div>
                    <div className="HomePageGoogleContaBox">
                        <img src={require(`../../Images/locationpin.png`)} />
                        <h3>Locaion</h3>
                        <h4>{CitiesData ? CitiesData.City : "Local"}</h4>
                    </div>
                </div>
            </div>
            <div className="HomePageGooglecALL">
                <div className="HomePageGooglecALLLeft">
                    <h1>Our Locksmiths <br /> Are Ready to Help!</h1>
                    <h2>Call Now For A Free No Obligation Estimate</h2>
                </div>
                <a href={`tel:${CitiePhone}`}>Click To Call Us Now!</a>

            </div>
        </div>
    )
}

